import store from "@/store";
import { LightBoxManager } from "@/modules/light-box/light-box.manager.js";

export const LightBoxPlugin = {
  install(Vue) {
    Vue.prototype.$lightBox = LightBoxManager(store);
  },
};
